/* eslint-disable i18next/no-literal-string */
import {
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { InspectEventsResponse } from "../settingsApi";
import { format } from "date-fns/format";
import { StripedAccordion } from "../styles";
import React from "react";

type Props = {
  event: InspectEventsResponse;
  index: number;
  expanded: number | boolean;
  handleChange: any;
};

const EventAccordion = ({ event, index, expanded, handleChange }: Props) => {
  const handleIconClick = (event: React.SyntheticEvent) => {
    handleChange(index, expanded);
    event.stopPropagation();
  };
  /**
   * When event is JeevesRowsAdded ("jvsRowsAdded") use different component to
   * show the results. This is just for helping testing single payslip jeeves rows and
   * will be removed after no longer needed
   */
  function componentToRenderEvent(event: InspectEventsResponse): JSX.Element {
    if (isJeevesRowsAddedEventResponse(event)) {
      return jeevesRowsComponent(event.payload);
    } else {
      return <pre>{JSON.stringify(event, null, 2)}</pre>;
    }
  }

  return (
    <StripedAccordion key={event.id} expanded={expanded === index}>
      <AccordionSummary
        sx={{ userSelect: "text", "&:hover": { cursor: "default !important" } }}
        expandIcon={
          <IconButton onClick={handleIconClick}>
            <ExpandMoreIcon />
          </IconButton>
        }
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography sx={{ width: "25%" }}>
          {format(new Date(event.time), "dd.MM.yyyy HH:mm:ss")}
        </Typography>
        <Typography sx={{ width: "33%" }}>{event.id}</Typography>
        <Typography sx={{ width: "17%" }}> {event.version}</Typography>
        <Typography sx={{ width: "25%" }}> {event.name}</Typography>
      </AccordionSummary>
      <AccordionDetails>{componentToRenderEvent(event)}</AccordionDetails>
    </StripedAccordion>
  );
};

function isJeevesRowsAddedEventResponse(
  event: InspectEventsResponse,
): event is JeevesRowsAddedEventsResponse {
  return event.name === "jvsRowsAdded";
}

function jeevesRowsComponent(event: JeevesRowsAddedEvent): JSX.Element {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Nmbr</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Account</TableCell>
            <TableCell>Sum</TableCell>
            <TableCell>Cost Center</TableCell>
            <TableCell>Customer Number</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {event.rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="left">{row.documentNumber}</TableCell>
              <TableCell align="left">{row.documentType}</TableCell>
              <TableCell align="left">{row.accountName}</TableCell>
              <TableCell align="left">{row.valueDate}</TableCell>
              <TableCell align="left">{row.accountCode}</TableCell>
              <TableCell align="left">{row.sum}</TableCell>
              <TableCell align="left">{row.costCenter}</TableCell>
              <TableCell align="left">{row.customerNumber}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

interface JeevesRowsAddedEventsResponse extends InspectEventsResponse {
  payload: JeevesRowsAddedEvent;
}

interface JeevesRow {
  documentNumber: number;
  documentType: string;
  accountName: string;
  valueDate: string;
  accountCode: string;
  sum: string;
  costCenter: string;
  customerNumber: string;
}

interface JeevesRowsAddedEvent {
  rows: JeevesRow[];
}

export default EventAccordion;
